module.exports = __webpack_public_path__ + "img/type_moving-floor.14d6ba24.jpg";